import React from 'react'
import styles from '../Panel_Control/AdminLogin/Formulario.module.scss'
import fondo from '../../img/bg3.jpg'
const Fondo = () => {
    return (
        
            <div className={styles.izq}>
                <img src={fondo} alt='img' />
            </div>
        
    )
}

export default Fondo